import React from "react";
import "./statusPill.css";

const STATUS_CLASS = {
  pending: "ai-status-pill--pending",
  approved: "ai-status-pill--approved",
  completed: "ai-status-pill--completed",
  processed: "ai-status-pill--approved",
  rejected: "ai-status-pill--rejected",
  cancelled: "ai-status-pill--cancelled"
};

export default function StatusPill({ status, className = "" }) {
  const normalized = String(status || "").trim().toLowerCase();
  const toneClass = STATUS_CLASS[normalized] || "ai-status-pill--pending";

  return (
    <span
      className={`ai-status-pill ${toneClass}${className ? ` ${className}` : ""}`}
    >
      {status}
    </span>
  );
}
